export default "__VITE_ASSET__CIA$WkjO__"